import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import {
  Button,
  Modal,
} from 'react-bootstrap';

import { Closing, Table } from 'services/action';
import { Form, DatePicker } from 'ui/components';

import { formatDate } from 'utilities/common';

const initialState = {
  month_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
  note: '',
};

export const FormGeneral = ({
  data,
  onClose,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const StateTable = useSelector((state) => state?.Table?.data['closing']);

  const [
    {
      month_at,
      note,
    },
    setState,
  ] = React.useState(initialState);

  const $handleRefresh = async () => {
    onClose();
    Dispatch(Table.$reload('closing', StateTable));
  }

  const $handleSubmit = async (c) => {
    const payload = {
      month_at: month_at?.formatted,
      note,
    };

    if (data) {
      const submit = await Dispatch(Closing.$update(data?.id, payload));
      if (submit?.message === 'success') {
        $handleRefresh();
      }
    } else {
      const submit = await Dispatch(Closing.$create(payload));
      if (submit?.message === 'success') {
        $handleRefresh();
      }
    };
  }

  React.useEffect(() => {
    if (!data) return

    setState((prevState) => ({
      ...prevState,
      month_at: {
        default: new Date(data?.monthly),
        formatted: formatDate(data?.monthly, 'YYYY-MM'),
      },
      note: data?.note,
    }));
  }, [data]);

  return (
    <>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label required">Pilih Bulan</label>
          <div
            className={
              StateForm?.errors?.month_at ? 'border border-danger rounded' : ''
            }
          >
            <DatePicker
              selectionMode="month"
              value={month_at?.default || null}
              format="yyyy/MM"
              onChange={(date) => {
                setState((prevState) => ({
                  ...prevState,
                  month_at: {
                    default: date,
                    formatted: formatDate(date, 'YYYY-MM'),
                  },
                }));
              }}
              isShowTrigger
              error={StateForm?.errors?.month_at}
            />
          </div>

          {StateForm?.errors?.month_at ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {StateForm?.errors?.month_at}
            </div>
          ) : null}
        </div>
        <Form.Textbox
          label="Keterangan"
          type="text"
          value={note}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              note: e.target.value,
            }))
          }
          error={StateForm?.errors?.note}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className='row w-100'>
          <div className='col'>
            <Button
              type="button"
              className='btn btn-light w-100'
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className='col'>
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '', 'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
